import { useState, useEffect } from 'react';

export default function useAnimatedCount(target = 0, duration = 800) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let start = null;

    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const percentage = Math.min(progress / duration, 1);
      setValue(Math.floor(target * percentage));
      if (progress < duration) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }, [target, duration]);

  return value;
}